import { render } from "./IndexSix.vue?vue&type=template&id=3b4a404c"
import script from "./IndexSix.vue?vue&type=script&lang=js"
export * from "./IndexSix.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__